import { useId, useLayoutEffect, useRef, useState, type ReactNode } from "react";
import { ChevronDown } from "lucide-react";
import { INVALID_SELECTOR } from "./reveal";

export function FormSection({
  title,
  defaultOpen = true,
  disabled = false,
  children,
}: {
  title: string;
  defaultOpen?: boolean;
  /** Campos só de leitura (fieldset desabilitado); o botão de abrir e fechar continua ativo. */
  disabled?: boolean;
  children: ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  const id = useId();
  const body = useRef<HTMLDivElement>(null);
  const hadInvalid = useRef(false);
  // Abre sozinha quando um campo interno passa a ser inválido; o usuário ainda pode fechá-la depois (FE11).
  // Roda a cada render de propósito (lê o DOM dos filhos); o setState só ocorre na transição sem erro → com erro.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useLayoutEffect(() => {
    const has = !!body.current?.querySelector(INVALID_SELECTOR);
    if (has && !hadInvalid.current) setOpen(true);
    hadInvalid.current = has;
  });
  return (
    <section className="box mb-3 card">
      <div className="box-header card-header">
        <h2 className="h6 mb-0">
          <button
            type="button"
            className="btn btn-link p-0 text-reset fw-semibold d-flex align-items-center gap-2 text-decoration-none"
            aria-expanded={open}
            aria-controls={id}
            onClick={() => setOpen(!open)}
          >
            <ChevronDown
              size={16}
              style={{ transform: open ? "none" : "rotate(-90deg)" }}
              aria-hidden="true"
            />
            {title}
          </button>
        </h2>
      </div>
      <div id={id} ref={body} hidden={!open} className="box-body card-body">
        <fieldset disabled={disabled}>
          <div className="row">{children}</div>
        </fieldset>
      </div>
    </section>
  );
}
